import { createScreenText } from 'helpers/screenText';
const st = createScreenText('audit_logs');

// src/pages/AuditLogs/types.ts
// TypeScript interfaces for Audit Logs feature

export interface AuditLog {
  id: number;
  tenantId: number;
  userId?: number;
  username?: string;
  email?: string;
  ipAddress?: string;
  userAgent?: string;
  action: string;
  actionType?: 'Created' | 'Updated' | 'Deleted' | 'Exported';
  module: string;
  entityType?: string;
  entityId?: number;
  description?: string;
  oldValue?: string;  // JSON string
  newValue?: string;  // JSON string
  result: 'Success' | 'Failed' | 'Warning';
  errorMessage?: string;
  timestamp: string;
  duration?: number; // milliseconds
}

export interface AuditLogStatistics {
  totalLogs: number;
  successCount: number;
  failedCount: number;
  warningCount: number;
  successRate: number;
  failureRate: number;
  averageDuration?: number;
  actionCounts: Record<string, number>;
  moduleCounts: Record<string, number>;
  topUsers: TopUserActivity[];
  actionTrends: ActionTrend[];
}

export interface TopUserActivity {
  userId: number;
  username: string;
  email: string;
  activityCount: number;
  successRate: number;
}

export interface ActionTrend {
  date: string;
  actionCounts: Record<string, number>;
}

// Nhóm hành động cố định — khớp SystemService.Features.AuditLogs.AuditActionTypes (backend).
// Dùng cho dropdown filter "Hành động" thay vì liệt kê Action chi tiết (Created, StatusChanged,
// CancelPrintExport,... hàng chục giá trị tự do do từng Command tự đặt tên).
export const ACTION_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'Created', label: st('tao_moi_label') },
  { value: 'Updated', label: st('cap_nhat_label') },
  { value: 'Deleted', label: st('xoa_label') },
  { value: 'Exported', label: st('xuat_du_lieu_button') },
];

export interface GetAuditLogsParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  action?: string;
  actionType?: string;
  module?: string;
  result?: string;
  userId?: number;
  fromDate?: string;
  toDate?: string;
  ipAddress?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}